<template>
  <div class="container">
    <Header></Header>
    <VideoList :data="videoList"></VideoList>
  </div>
</template>

<script>
import VideoList from "@/modules/videoList.vue";
import Header from "@/modules/header.vue";
import { getCategories, pageCourse } from "@/assets/js/axios.js";

export default {
  name: "continue",

  data() {
    return {
      navbarData: [],
      videoList: []
    };
  },

  created() {
    getCategories().then(data => {
      if (parseInt(data.code) === 1) {
        this.navbarData = data;
        pageCourse(this.navbarData.data[4].ccid).then(data => {
          if (parseInt(data.code) === 1) {
            this.videoList = data.data.dataList;
          }
        });
      } else {
        this.videoList = 0;
      }
    });
  },
  components: {
    VideoList,
    Header
  }
};
</script>



// WEBPACK FOOTER //
// src/components/continue.vue